module.exports = __webpack_public_path__ + "assets/images/burger.86e35729.svg";